import React from "react";
import { Check, Crown, Info } from "lucide-react";
import { toast } from "sonner";

const money = (v) => `$${Number(v).toFixed(2)}`;

const limitLabel = (p) => p.unlimited_products ? "Unlimited products"
  : p.product_limit != null ? `Up to ${p.product_limit.toLocaleString()} products` : "—";

export const PlanCard = ({ plan, current, onJoin, joinDisabled, joinLabel }) => {
  const isPro = plan.is_pro_ecommerce;
  const isCurrent = current === plan.id;
  return (
    <div data-testid={`plan-card-${plan.id}`}
      className={`relative flex flex-col bg-white border p-6 ${isPro ? "border-taven-gold shadow-xl" : "border-black/10"}`}>
      {isPro && <span className="absolute -top-3 left-6 bg-taven-gold text-black text-[10px] font-black uppercase tracking-wider px-3 py-1 flex items-center gap-1"><Crown className="w-3 h-3" /> Complete Membership</span>}
      {isCurrent && <span className="absolute -top-3 right-6 bg-taven-black text-white text-[10px] font-black uppercase tracking-wider px-3 py-1" data-testid={`plan-current-${plan.id}`}>Current Plan</span>}
      <h3 className="text-xl font-black font-display tracking-tight">{plan.name}</h3>
      <p className="text-sm text-muted-foreground mt-1 min-h-[2.5rem]">{plan.description}</p>
      <div className="mt-3 flex items-end gap-1">
        <span className="text-4xl font-black font-display">{money(plan.price)}</span>
        <span className="text-sm text-muted-foreground mb-1">/{plan.billing_interval === "monthly" ? "mo" : plan.billing_interval}</span>
      </div>
      <p className="mt-2 text-xs font-bold uppercase tracking-wider text-taven-orange">{limitLabel(plan)}</p>

      <ul className="mt-4 space-y-1.5 flex-1">
        {(plan.features || []).map((f, i) => (
          <li key={i} className="flex items-start gap-2 text-sm"><Check className="w-4 h-4 text-taven-gold shrink-0 mt-0.5" />{f}</li>
        ))}
      </ul>

      {plan.included_with_pro && !isPro && (
        <p className="mt-3 flex items-center gap-1.5 text-[11px] font-bold text-taven-gold bg-taven-gold/10 px-2 py-1.5" data-testid={`plan-included-${plan.id}`}>
          <Info className="w-3.5 h-3.5" /> Included with Pro E-Commerce Membership
        </p>
      )}

      <button
        onClick={() => onJoin && onJoin(plan)}
        disabled={isCurrent || plan.visibility === "coming_soon" || !plan.available_for_registration || joinDisabled}
        data-testid={`plan-join-${plan.id}`}
        className={`mt-5 py-3 text-xs font-bold uppercase tracking-wider transition-colors disabled:opacity-50 ${isPro ? "bg-taven-gold text-black hover:bg-taven-orange hover:text-white" : "bg-taven-black text-white hover:bg-taven-orange"}`}>
        {isCurrent ? "Your Membership" : joinDisabled ? (joinLabel || "Coming Soon")
          : plan.visibility === "coming_soon" ? "Coming Soon"
          : !plan.available_for_registration ? "Unavailable" : (joinLabel || (current ? "Upgrade" : "Apply"))}
      </button>
      <p className="mt-2 text-[10px] text-center text-muted-foreground">Paid membership · recurring monthly · approval required</p>
    </div>
  );
};

export const PlanGrid = ({ plans, current, onJoin, joinDisabled, joinLabel }) => (
  <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="plan-grid">
    {plans.map((p) => <PlanCard key={p.id} plan={p} current={current} onJoin={onJoin} joinDisabled={joinDisabled} joinLabel={joinLabel} />)}
  </div>
);

export default PlanGrid;
